import { Button, Heading, Notice, Separator, Spinner, Text } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import LogoutButton from '../mandate/LogoutButton';
import GaDataStore from '../stores/GaDataStore';
import useStores from '../stores/UseStores';
import { isSmallModuleView } from '../util/ModuleUtil';
import WrapWithContainerInFullPage from '../wrapper/WrapWithContainerInFullPage';

const QUERY_FAILED_KEY = 'mandates.choicesQueryFailed';
const SOFT_PROFILE_KEY = 'mandates.softProfile';

const getNoticeKey = (softProfile: boolean) => {
  return softProfile ? SOFT_PROFILE_KEY : QUERY_FAILED_KEY;
};

const MandatesErrorPage = observer((): React.JSX.Element => {
  const {
    mandateStore: { isFetching, isFetchingMore, softProfile, continueFailedMandates },
    translateStore: { translate },
    uiStore: { componentWidth },
  } = useStores();

  const handleContinue = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    event.preventDefault();
    return continueFailedMandates();
  };

  if (isFetching) {
    return <Spinner />;
  }

  const queryFailedMessage = translate(getNoticeKey(softProfile));

  if (!softProfile) {
    GaDataStore.error(queryFailedMessage);
  }

  return (
    <WrapWithContainerInFullPage>
      <Text>
        <LogoutButton />
        <Heading className="h4">{translate('mandates.title')}</Heading>
        <Separator color="invisible" spacing="xsmall" />
        <Notice size={isSmallModuleView(componentWidth) ? 'small' : undefined} type={softProfile ? 'info' : 'error'}>
          {queryFailedMessage}
        </Notice>
        <Separator spacing="medium" color="invisible" />
        {!softProfile && (
          <p className="text-center">
            <Button
              text={translate('mandates.choicesQueryFailed.continue')}
              onClick={(event) => handleContinue(event)}
              isLoading={isFetchingMore}
              iconRight="#arrow-right"
            />
          </p>
        )}
      </Text>
    </WrapWithContainerInFullPage>
  );
});

export default MandatesErrorPage;
